import { render, staticRenderFns } from "./ImageIcon.vue?vue&type=template&id=66f635f8&scoped=true"
import script from "./ImageIcon.vue?vue&type=script&lang=js"
export * from "./ImageIcon.vue?vue&type=script&lang=js"
import style0 from "./ImageIcon.vue?vue&type=style&index=0&id=66f635f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f635f8",
  null
  
)

export default component.exports